import { html } from "lit";
var icon_build_default = () => html`
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.82 2.31a7.698 7.698 0 00-1.78 7.907l.112.301L.67 18.995a2.292 2.292 0 000 3.244l1.09 1.091c.43.43 1.014.672 1.622.672l.202-.009a2.293 2.293 0 001.42-.663l8.476-8.476.032.014a7.699 7.699 0 009.673-10.626.75.75 0 00-1.201-.195l-3.55 3.546a.75.75 0 01-1.06 0l-.8-.8a.75.75 0 010-1.06l3.6-3.6a.75.75 0 00-.172-1.19 7.697 7.697 0 00-8.98 1.166l-.203.2zm7.245-.556l.275.089-2.827 2.829a2.25 2.25 0 000 3.183l.8.8.129.119a2.25 2.25 0 003.052-.12l2.745-2.742.065.23a6.2 6.2 0 01-8.671 7.145.75.75 0 00-.853.147L3.944 22.27a.793.793 0 01-1.122 0L1.73 21.178a.792.792 0 01-.001-1.121l8.843-8.837a.75.75 0 00.147-.854 6.197 6.197 0 017.345-8.612z" />
  </svg>
`;
export {
  icon_build_default as default
};
//# sourceMappingURL=icon-build.js.map
